import {
  TRAILSINFO_LIST_SET,
  TRAILSINFO_LIST_REQUEST,
  TRAILSINFO_LIST_STATUS_RESET,
  TRAILSINFO_LIST_SUCCESS,
  TRAILSINFO_LIST_ERROR,
  TRAILSINFO_QUERY_UPDATE,
  TRAILSINFO_QUERY_SUCCESS,
  MITIGATED_TRAILS_SET,
  MITIGATED_TRAILS_REQUEST,
  MITIGATED_TRAILS_SUCCESS,
  MITIGATED_TRAILS_ERROR,
  REOPENED_TRAILS_SET,
  REOPENED_TRAILS_REQUEST,
  REOPENED_TRAILS_SUCCESS,
  REOPENED_TRAILS_ERROR,
  REOPENED_TRAILS_STATUS_RESET,
  ACTIVE_TRAIL_RANGE_REQ,
  ACTIVE_TRAIL_RANGE_REQ_SUCCESS,
  ACTIVE_TRAIL_RANGE_REQ_ERROR,
  MITIGATED_TRAIL_RANGE_REQ,
  MITIGATED_TRAIL_RANGE_REQ_SUCCESS,
  MITIGATED_TRAIL_RANGE_REQ_ERROR,
  REOPENED_TRAIL_RANGE_REQ,
  REOPENED_TRAIL_RANGE_REQ_SUCCESS,
  REOPENED_TRAIL_RANGE_REQ_ERROR,
  ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ,
  SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES,
  REOPENED_PROGRESSION_VIEW_PREFERENCES_REQ,
  SAVE_REOPENED_PROGRESSION_VIEW_PREFERENCES,
  MITIGATED_PROGRESSION_VIEW_PREFERENCES_REQ,
  SAVE_MITIGATED_PROGRESSION_VIEW_PREFERENCES
} from './trailsinfo.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Trail from '@/resources/models/Trail'
import { getDateRangeChoice, getTimeSinceMidnight } from '@/utilities/datetime.helper'
import { trailsMetaInfo } from '@/column-header/trail/trails-meta'
import { OrderByEnum } from '@/constants/orderby.constants'

const state = {
  trailsinfoReqStatus: '',
  trailsinfoRecords: {},
  activeTrailsinfoRecords: {},
  reopenedTrailsinfoReqStatus: '',
  reopenedTrailsinfoRecords: {},
  trailsAssignmentStatus: '',
  mitigatedTrailsReqStatus: '',
  mitigatedTrailsRecords: {},
  activeProgressionPreferences: [],
  reopenedProgressionPreferences: [],
  mitigatedProgressionPreferences: []
}

const getters = {
  trailsinfoReqStatus: state => state.trailsinfoReqStatus,
  trailsinfoRecords: state => state.trailsinfoRecords,
  activeTrailsinfoRecords: state => state.activeTrailsinfoRecords,
  reopenedTrailsinfoReqStatus: state => state.reopenedTrailsinfoReqStatus,
  reopenedTrailsinfoRecords: state => state.reopenedTrailsinfoRecords,
  mitigatedTrailsReqStatus: state => state.mitigatedTrailsReqStatus,
  mitigatedTrailsRecords: state => state.mitigatedTrailsRecords,
  activeProgressionPreferences: state => state.activeProgressionPreferences,
  reopenedProgressionPreferences: state => state.reopenedProgressionPreferences,
  mitigatedProgressionPreferences: state => state.mitigatedProgressionPreferences
}

// Best Practice - updates state
const mutations = {
  [TRAILSINFO_LIST_SET]: (state, { trailState, data } = {}) => {
    state.activeTrailsinfoRecords = data
  },
  [TRAILSINFO_LIST_REQUEST]: state => {
    state.trailsinfoReqStatus = 'loading'
  },
  [TRAILSINFO_LIST_STATUS_RESET]: state => {
    state.trailsinfoReqStatus = ''
  },
  [TRAILSINFO_LIST_SUCCESS]: (state, data) => {
    state.trailsinfoReqStatus = 'saved'
  },
  [TRAILSINFO_LIST_ERROR]: (state, errMsg) => {
    state.trailsinfoReqStatus = 'error'
  },
  [REOPENED_TRAILS_SET]: (state, { trailState, data } = {}) => {
    state.reopenedTrailsinfoRecords = data
  },
  [REOPENED_TRAILS_REQUEST]: state => {
    state.reopenedTrailsinfoReqStatus = 'loading'
  },
  [REOPENED_TRAILS_SUCCESS]: (state, data) => {
    state.reopenedTrailsinfoReqStatus = 'saved'
  },
  [REOPENED_TRAILS_ERROR]: (state, errMsg) => {
    state.reopenedTrailsinfoReqStatus = 'error'
  },
  [REOPENED_TRAILS_STATUS_RESET]: (state, errMsg) => {
    state.reopenedTrailsinfoReqStatus = ''
  },
  [TRAILSINFO_QUERY_UPDATE]: state => {
    state.trailsinfoReqStatus = 'loading'
  },
  [TRAILSINFO_QUERY_SUCCESS]: state => {
    state.trailsinfoReqStatus = 'saved'
  },
  [MITIGATED_TRAILS_SET]: (state, data) => {
    state.mitigatedTrailsRecords = data
  },
  [MITIGATED_TRAILS_REQUEST]: state => {
    state.mitigatedTrailsReqStatus = 'loading'
  },
  [MITIGATED_TRAILS_SUCCESS]: (state, data) => {
    state.mitigatedTrailsReqStatus = 'saved'
  },
  [MITIGATED_TRAILS_ERROR]: (state, errMsg) => {
    state.mitigatedTrailsReqStatus = 'error'
  },
  [ACTIVE_TRAIL_RANGE_REQ]: state => {},
  [ACTIVE_TRAIL_RANGE_REQ_SUCCESS]: state => {},
  [ACTIVE_TRAIL_RANGE_REQ_ERROR]: state => {},
  [MITIGATED_TRAIL_RANGE_REQ]: state => {},
  [MITIGATED_TRAIL_RANGE_REQ_SUCCESS]: state => {},
  [MITIGATED_TRAIL_RANGE_REQ_ERROR]: state => {},
  [REOPENED_TRAIL_RANGE_REQ]: state => {},
  [REOPENED_TRAIL_RANGE_REQ_SUCCESS]: state => {},
  [REOPENED_TRAIL_RANGE_REQ_ERROR]: state => {},
  [ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.activeProgressionPreferences = data
  },
  [REOPENED_PROGRESSION_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.reopenedProgressionPreferences = data
  },
  [MITIGATED_PROGRESSION_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.mitigatedProgressionPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserProgressionPrefs = data.find(pref => {
            return pref.tbl_id === 3 && pref.user_id === uid
          })
          context.commit(ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ, currUserProgressionPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [REOPENED_PROGRESSION_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserReopenedProgressionPrefs = data.find(pref => {
            return pref.tbl_id === 4 && pref.user_id === uid
          })
          context.commit(REOPENED_PROGRESSION_VIEW_PREFERENCES_REQ, currUserReopenedProgressionPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_REOPENED_PROGRESSION_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [MITIGATED_PROGRESSION_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserMitigatedProgressionPrefs = data.find(pref => {
            return pref.tbl_id === 5 && pref.user_id === uid
          })
          context.commit(MITIGATED_PROGRESSION_VIEW_PREFERENCES_REQ, currUserMitigatedProgressionPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_MITIGATED_PROGRESSION_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [TRAILSINFO_LIST_REQUEST] (context, { trailState, dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.dashboardProgressionDateRangeUserSetting)
    }
    let trailsUrl = `/trails/${lastXHours.hours}`

    if (lastXHours.value === 'SINCE_MIDNIGHT') {
      let timeSinceMidnight = getTimeSinceMidnight()
      trailsUrl = `/trails/active/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
        timeSinceMidnight.endtime
      )}`
    }
    return new Promise((resolve, reject) => {
      context.commit(TRAILSINFO_LIST_REQUEST)
      ApiRest()
        .get(trailsUrl)
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.riskScore - a.riskScore
            })
            .map(trail => {
              let attackTrail = new Trail('trailIdHash', trail)
              attackTrail.configureKillChainFormat()
              return attackTrail
            })
            .value()

          data = new IQCollection(
            data,
            { attributes: trailsMetaInfo.meta.columns },
            { defaultSort: 'progressionSeverity', sortOrder: OrderByEnum.DESC }
          )
          context.commit(TRAILSINFO_LIST_SET, { data: data })
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAILSINFO_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAILSINFO_LIST_SUCCESS] (context) {
    context.commit(TRAILSINFO_LIST_SUCCESS)
  },
  [TRAILSINFO_LIST_STATUS_RESET] (context) {
    context.commit(TRAILSINFO_LIST_STATUS_RESET)
  },
  [REOPENED_TRAILS_REQUEST] (context, { trailState, dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.dashboardProgressionDateRangeUserSetting)
    }
    let trailsUrl = `/trails/reopened/${lastXHours.hours}`
    if (lastXHours.value === 'SINCE_MIDNIGHT') {
      let timeSinceMidnight = getTimeSinceMidnight()
      trailsUrl = `/trails/reopened/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
        timeSinceMidnight.endtime
      )}`
    }
    return new Promise((resolve, reject) => {
      context.commit(REOPENED_TRAILS_REQUEST)
      ApiRest()
        .get(trailsUrl)
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.riskScore - a.riskScore
            })
            .map(trail => {
              let attackTrail = new Trail('trailIdHash', trail)
              attackTrail.configureKillChainFormat()
              return attackTrail
            })
            .value()

          data = new IQCollection(
            data,
            { attributes: trailsMetaInfo.meta.columns },
            { defaultSort: 'progressionSeverity', sortOrder: OrderByEnum.DESC }
          )

          context.commit(REOPENED_TRAILS_SET, { data: data })
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(REOPENED_TRAILS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [REOPENED_TRAILS_SUCCESS] (context) {
    context.commit(REOPENED_TRAILS_SUCCESS)
  },
  [REOPENED_TRAILS_STATUS_RESET] (context) {
    context.commit(REOPENED_TRAILS_STATUS_RESET)
  },
  [TRAILSINFO_QUERY_UPDATE] (context, payload) {
    context.commit(TRAILSINFO_QUERY_UPDATE)

    if (payload.assignee === 'All') {
      payload.trailInfoCollection.forEach(trail => {
        trail.visible = true
      })
    } else {
      payload.trailInfoCollection.forEach(trail => {
        if (trail.ownerId !== payload.assignee) {
          trail.visible = false
        }
      })
    }
    setTimeout(() => {
      context.commit(TRAILSINFO_QUERY_SUCCESS)
    })
  },
  [MITIGATED_TRAILS_REQUEST] (context, { state, dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.dashboardProgressionDateRangeUserSetting)
    }
    let trailsUrl = `/trails/mitigated/${lastXHours.hours}`

    if (lastXHours.value === 'SINCE_MIDNIGHT') {
      let timeSinceMidnight = getTimeSinceMidnight()
      trailsUrl = `/trails/mitigated/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
        timeSinceMidnight.endtime
      )}`
    }
    return new Promise((resolve, reject) => {
      context.commit(MITIGATED_TRAILS_REQUEST)
      ApiRest()
        .get(trailsUrl)
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.riskScore - a.riskScore
            })
            .map(trail => {
              let attackTrail = new Trail('trailIdHash', trail)
              attackTrail.configureKillChainFormat()
              return attackTrail
            })
            .value()

          data = new IQCollection(
            data,
            { attributes: trailsMetaInfo.meta.columns },
            { defaultSort: 'progressionSeverity', sortOrder: OrderByEnum.DESC }
          )

          context.commit(MITIGATED_TRAILS_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(MITIGATED_TRAILS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [MITIGATED_TRAILS_SUCCESS] (context) {
    context.commit(MITIGATED_TRAILS_SUCCESS)
  },
  [ACTIVE_TRAIL_RANGE_REQ] (context) {
    let timeSinceMidnight = getTimeSinceMidnight()

    return new Promise((resolve, reject) => {
      context.commit(ACTIVE_TRAIL_RANGE_REQ)
      ApiRest()
        .get(
          `/trails/active/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
            timeSinceMidnight.endtime
          )}`
        )
        .then(({ data }) => {
          context.commit(ACTIVE_TRAIL_RANGE_REQ_SUCCESS, data)

          resolve(data)
        })
        .catch(errMsg => {
          context.commit(ACTIVE_TRAIL_RANGE_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [MITIGATED_TRAIL_RANGE_REQ] (context) {
    let timeSinceMidnight = getTimeSinceMidnight()

    return new Promise((resolve, reject) => {
      context.commit(MITIGATED_TRAIL_RANGE_REQ)
      ApiRest()
        .get(
          `/trails/mitigated/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
            timeSinceMidnight.endtime
          )}`
        )
        .then(({ data }) => {
          context.commit(MITIGATED_TRAIL_RANGE_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(MITIGATED_TRAIL_RANGE_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [REOPENED_TRAIL_RANGE_REQ] (context) {
    let timeSinceMidnight = getTimeSinceMidnight()

    return new Promise((resolve, reject) => {
      context.commit(REOPENED_TRAIL_RANGE_REQ)
      ApiRest()
        .get(
          `/trails/reopened/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
            timeSinceMidnight.endtime
          )}`
        )
        .then(({ data }) => {
          context.commit(REOPENED_TRAIL_RANGE_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(REOPENED_TRAIL_RANGE_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/trailsinfo.module.js